/* HeaderLozenges.styles.ts generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _15 = "._1az0idpf li:last-of-type{margin-right:0}";
const _14 = "._qwjmweh0 li{margin:0 var(--ds-space-100,8px) var(--ds-space-050,4px) 0}";
const _13 = "._1n261g80{flex-wrap:wrap}";
const _12 = "._1bahv2br{justify-content:start}";
const _11 = "._4cvr1h6o{align-items:center}";
const _10 = "._1e0c1txw{display:flex}";
const _9 = "._19bvidpf{padding-left:0}";
const _8 = "._n3tdidpf{padding-bottom:0}";
const _7 = "._u5f3idpf{padding-right:0}";
const _6 = "._ca0qidpf{padding-top:0}";
const _5 = "._18u0idpf{margin-left:0}";
const _4 = "._otyridpf{margin-bottom:0}";
const _3 = "._2hwxidpf{margin-right:0}";
const _2 = "._19pkidpf{margin-top:0}";
const _ = "._qtt8glyw{list-style:none}";
export const LozengeList = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "ul",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _1bahv2br _1n261g80 _qwjmweh0 _1az0idpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LozengeList.displayName = 'LozengeList';
}